export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
    fixed: 'left',
  },
  {
    title: that.$l('table_label_displayAccount') || '银行账号',
    field: 'displayAccount',
    headerAlign: 'center',
    align: 'left',
    minWidth: 220,
    slots: { default: 'displayAccount' },
  },
  {
    title: that.$l('table_label_bankName') || '开户银行',
    field: 'bankName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 220,
  },
  {
    title: that.$l('table_label_displayBankType') || '账户性质',
    field: 'displayBankType',
    align: 'center',
    width: 100,
    slots: { default: 'displayBankType' },
  },
]
